import { render, staticRenderFns } from "./ValueOfGoodsHSCodeHeader.vue?vue&type=template&id=114a0e49"
import script from "./ValueOfGoodsHSCodeHeader.vue?vue&type=script&lang=js"
export * from "./ValueOfGoodsHSCodeHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports